export const IL = () => {
  return (
    <>
      <g clipPath="url(#clip0_1073_11546)">
      <g clipPath="url(#clip1_1073_11546)">
      <rect x="96" y="20" width="96" height="20" transform="rotate(180 96 20)" fill="white"/>
      <rect x="96" y="96" width="96" height="20" transform="rotate(180 96 96)" fill="white"/>
      <rect x="96" y="88" width="96" height="80" transform="rotate(180 96 88)" fill="#0066FF"/>
      <rect x="96" y="76" width="96" height="56" transform="rotate(180 96 76)" fill="white"/>
      <circle cx="48" cy="48" r="16" fill="#0066FF"/>
      </g>
      </g>
      <rect x="2" y="2" width="92" height="92" rx="46" stroke="white" strokeOpacity="0.15" strokeWidth="4"/>
      <defs>
      <clipPath id="clip0_1073_11546">
      <rect width="96" height="96" rx="48" fill="white"/>
      </clipPath>
      <clipPath id="clip1_1073_11546">
      <rect width="96" height="96" rx="24" fill="white"/>
      </clipPath>
      </defs>
    </>
  )
}
